module.exports = __webpack_public_path__ + "static/img/66.441c621.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/66.jpg
// module id = jymH
// module chunks = 0